export const productPageTitles = [
    'General information',
    'Wuxal benefits',
    'Related products',
    'Composition & compatibility',
    'Wuxal crop nutrition programs',
    'Wuxal trial results',
    'Wuxal catalog',
];

export const relatedProductPageTitles = [
    'General information',
    'Formula',
    'Benefits',
    'Technical information',
    'Trial results',
    'crop nutrition programs',
    'Related products',
];
